import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomInput from "../../components/customInput/CustomInput";
import { useState } from "react";

function Product({
  templateList,
  language,
  onInputChange,
  onShowUploadFile,
  onShowDeleteFile,
}) {
  const productState = useSelector((state) => state.product);
  const error = productState.error;
  const product = productState.data || {};
  const basicInfo = product.basicInfo || product.contentData?.basicInfo || {};

  const [dateError, setDateError] = useState('');

  const handleDateChange = (key, date) => {
    const dateString = date ? date.toISOString().split('T')[0] : "";

    if (key === 'endDate' && basicInfo.startDate) {
      const startDate = new Date(basicInfo.startDate);
      if (date <= startDate) {
        setDateError('The end date must be later than the start date.');
        return;
      } else {
        setDateError('');
      }
    } else if (key === 'startDate' && basicInfo.endDate) {
      const endDate = new Date(basicInfo.endDate);
      if (date >= endDate) {
        setDateError('The end date must be later than the start date.');
      } else {
        setDateError('');
      }
    } else {
      setDateError('');
    }

    onInputChange(key, dateString, language);
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    return new Date(dateString);
  };

  const handleInputChange = (key, value) => {
    const template = templateList.find(t => t.id === key);

    if (template) {
      if (template.type === "checkbox") {
        onInputChange(key, value, language);
        return;
      }

      if (template.id === "name" && template.maxLength && value.length > template.maxLength) {
        value = value.slice(0, template.maxLength);
      } else if (template.id === "des" && template.maxLength && value.length > template.maxLength) {
        value = value.slice(0, template.maxLength);
      } else if (template.id === "day" && template.pattern) {
        if (value && !template.pattern.test(value)) {
          return;
        }
      } else if (template.id === "price" && template.pattern) {
        if (value && !template.pattern.test(value)) {
          return;
        }
      }
    }

    onInputChange(key, value, language);
  };

  const handleCheckboxChange = (key, checked) => {
    onInputChange(key, checked, language);
  };

  const CustomDateInput = ({ value, onClick, placeholder }) => (
    <input
      type="text"
      className="custom-input"
      value={value || ""}
      onClick={onClick}
      readOnly
      placeholder={placeholder}
      style={{
        width: "100%",
        padding: "8px 12px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        fontSize: "14px"
      }}
    />
  );

  return (
    <div className="tab-package-container">
      {templateList.map((template, index) => {
        if (template.type === "text") {
          return (
            <div key={index} className="package-input">
              <label>
                {template.label}
                {template.required && <span className="required-asterisk">*</span>}
                :
              </label>
              <div style={{ width: "73%", position: "relative" }}>
                <CustomInput
                  type="text"
                  value={basicInfo[template.id] || ""}
                  onChange={(e) => handleInputChange(template.id, e.target.value)}
                  placeholder={template.placeholder[language]}
                  customStyle={{ width: "100%" }}
                  error={error?.[template.id]}
                  maxLength={template.maxLength || undefined}
                />
                {(template.id === "name" || template.id === "des") && template.maxLength && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: basicInfo[template.id]?.length > template.maxLength ? "red" : "#666",
                      textAlign: "right",
                      marginTop: "4px"
                    }}
                  >
                    {basicInfo[template.id]?.length || 0}/{template.maxLength}
                  </div>
                )}
              </div>
            </div>
          );
        }

        if (template.type === "textarea") {
          return (
            <div key={index} className="package-input">
              <label>
                {template.label}
                {template.required && <span className="required-asterisk">*</span>}
                :
              </label>
              <div style={{ width: "73%", position: "relative" }}>
                <textarea
                  value={basicInfo[template.id] || ""}
                  onChange={(e) => handleInputChange(template.id, e.target.value)}
                  placeholder={template.placeholder[language]}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    fontSize: "14px",
                    minHeight: "50px",
                    backgroundColor: '#F6F6F6'
                  }}
                  maxLength={template.maxLength || undefined}
                />
                {error?.[template.id] && (
                  <div className="error-message" style={{ color: "#dc3545", fontSize: "16px" }}>
                    {error[template.id]}
                  </div>
                )}
                {template.maxLength && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: basicInfo[template.id]?.length > template.maxLength ? "red" : "#666",
                      textAlign: "right",
                      marginTop: "4px"
                    }}
                  >
                    {basicInfo[template.id]?.length || 0}/{template.maxLength}
                  </div>
                )}
              </div>
            </div>
          );
        }

        if (template.type === "date") {
          const isEndDate = template.id === "endDate";

          return (
            <div key={index} className="package-input">
              <label>
                {template.label}
                {template.required && <span className="required-asterisk">*</span>}
                :
              </label>
              <div style={{ width: "73%" }}>
                <DatePicker
                  selected={parseDate(basicInfo[template.id])}
                  onChange={(date) => handleDateChange(template.id, date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText={template.placeholder[language]}
                  customInput={<CustomDateInput placeholder={template.placeholder[language]} />}
                  className="custom-input"
                  wrapperClassName="date-picker-wrapper"
                  style={{ width: "100%" }}
                  minDate={isEndDate ? parseDate(basicInfo.startDate) : null}
                  showIcon
                />
                {error?.[template.id] && (
                  <div className="error-message" style={{ color: "#dc3545", fontSize: "16px" }}>
                    {error[template.id]}
                  </div>
                )}
                {isEndDate && dateError && (
                  <div className="error-message" style={{ color: "#dc3545", fontSize: "16px" }}>
                    {dateError}
                  </div>
                )}
              </div>
            </div>
          );
        }

        if (template.type === "checkbox") {
          return (
            <div key={index} className="package-input" style={{ alignItems: 'baseline' }}>
              <label>
                {template.label}:
              </label>
              <div style={{ width: "73%", display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={basicInfo[template.id] || false}
                  onChange={(e) => handleCheckboxChange(template.id, e.target.checked)}
                  style={{
                    width: "16px",
                    height: "16px",
                  }}
                />
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}

export default Product;